import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Card } from '#pie/components/card/Card';
import { DataTable } from '#pie/components/data-table/DataTable';
import { InputSearch } from '#pie/components/input-search/InputSearch';
import { Stack } from '#pie/components/stack/Stack';
import { Text } from '#pie/components/text/Text';
import { useDataTable } from '#pie/hooks/useDataTable';
import { getManagementContacts } from '#pie/internal/api/pie-bff';
import { contactSortingAtom } from '#pie/stores/contact';
import { searchAtom } from '#pie/stores/search';
import { emptyFilterAtom } from '#pie/stores/searchOnlyFilter';

export const ContactPersonManagement = () => {
  const { t } = useTranslation();

  /* istanbul ignore next -- @preserve */
  const tableProps = useDataTable({
    columns: (helper) => [
      helper.accessor('fullName', {
        header: t('common.name'),
        meta: { columnWidth: 200 },
      }),
      helper.accessor('email', {
        header: t('common.email'),
        meta: { columnWidth: 250 },
      }),
      helper.accessor('phone', {
        header: t('common.phone'),
        meta: { columnWidth: 200 },
      }),
      helper.accessor('contactGroupMemberships', {
        header: t('common.tab.contact_group'),
        cell: (info) => {
          const memberships = info.getValue();
          const count = memberships?.length ?? 0;
          return <Text>{count}</Text>;
        },
      }),
    ],
    dateKeys: [],
    filtersAtom: emptyFilterAtom,
    query: getManagementContacts,
    sortingAtom: contactSortingAtom,
  });

  const [search, setSearch] = useAtom(searchAtom);

  return (
    <section className="flex items-start gap-6">
      <Card className="flex-1 overflow-x-hidden p-4">
        <Stack gap="md">
          <div className="px-3" role="toolbar">
            <Stack direction="row" gap="md" className="items-center">
              <InputSearch
                value={search || ''}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={t('common.search.placeholder')}
                onClear={() => setSearch('')}
              />
            </Stack>
          </div>
          <DataTable
            rowLinks={(row) => ({
              'aria-label': row.original.fullName,
              to: row.original.id,
            })}
            {...tableProps}
          />
        </Stack>
      </Card>
    </section>
  );
};
